import cn from 'classnames'
import { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from '../../helpers/createStyles'
import { theme } from '../../styles/theme'
import ResponsiveImage from '../ResponsiveImage'

const GallerySlide = ({
  image,
  index,
  activeIndex,
  onSelect,
  onClose,
  onZoom,
  setRefs
}) => {
  const styles = useStyles()
  const rootRef = useRef()
  const imageRef = useRef()
  const isActive = index === activeIndex

  const handlePress = useCallback(
    event => {
      if (isActive) {
        if (event.target === rootRef?.current) {
          onClose()
        } else {
          onZoom(index)
        }
      } else {
        onSelect(index)
      }
    },
    [isActive, onClose, onZoom, onSelect, index]
  )

  useEffect(() => {
    setRefs(index, {
      root: rootRef.current,
      image: imageRef.current
    })
  }, [setRefs, index])

  return (
    <button
      ref={rootRef}
      className={styles.root}
      onClick={handlePress}
    >
      <div ref={imageRef} className={cn(styles.container)}>
        <ResponsiveImage fadeIn={false} showPreview={false} image={image} className={styles.imageContainer} classNames={{ image: styles.image }} />
      </div>
    </button>
  )
}

const useStyles = createUseStyles({
  root: {
    height: '100%',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: '0 none',
    [theme.breakpoints.up('sm')]: {
      height: '100vh',
      width:
        'calc(var(--box-width) + ((100vw - var(--box-width)) / 2) - var(--peek))',
      cursor: 'none!important'
    }
  },
  container: {
    position: 'relative',
    height: '100%',
    width: 'var(--box-width)',
    maxHeight: 'calc(100vh - (var(--gutter) * 2) - 120px)',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      maxHeight: 'calc(100vh - (var(--gutter) * 2))'
    },
    '& picture, & img': {
      objectPosition: '50% 50% !important'
    }
  },
  imageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  image: {
    objectFit: 'contain'
  }
})

GallerySlide.propTypes = {
  image: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onZoom: PropTypes.func.isRequired
}

export default GallerySlide
